import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { permissionObj } from '../../../../../../Helpers/permission';
import SubViewOptions from '../SubViewOptions';
import CustomTabContainer from '../../../../../../components/CustomTabContainer';
import CustomTab from '../../../../../../components/CustomTab';
import GlobalDeductionPolicySection from './SubComponents/DeductionPolicySection';
import UserDeductionPolicySection from '../DeductionPolicyUser/UserDeductionPolicySection';
import { DEDUCTION_POLICY_TAB } from './Model/Model';
import SearchSimple from "../../../../../../components/SearchSimples/SearchSimple";
import { TABLES } from '../../../../../../Apis/Tables';

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTitle: Full Stack Developer
 */
const DeductionPolicy = ({
    subView, changeSubViewManage, registerAction, subViewChild, setSubViewChild,
    setBodyForExport, searchElement, setSearchElement, setSimpleSearch, search, setSearch,
    selectForDelete, setSelectForDelete, setIsAllChecked,
}) => {
    const { t } = useTranslation();
    const DEV = useSelector((s) => s?.CommonsSlice?.development);
    const { permission } = useSelector((s) => s.authenticatioauthennSlice);
    const [activeTab, setActiveTab] = useState(subViewChild);
    const [searchResults, setSearchResults] = useState(null);

    const canGlobal = DEV || permission?.includes(permissionObj?.WEB_PAYROLL_DEDUCTION_POLICY_READ);
    const canUser = DEV || permission?.includes(permissionObj?.WEB_PAYROLL_DEDUCTION_POLICY_USER_READ);

    // Only show tabs the user is allowed to read.
    const visibleTabs = DEDUCTION_POLICY_TAB.getTabs().filter((tab) => {
        if (tab.key === DEDUCTION_POLICY_TAB.GLOBAL.key) return canGlobal;
        if (tab.key === DEDUCTION_POLICY_TAB.USER.key) return canUser;
        return false;
    });

    return (
        <>
            <div className={`d-flex input-padding-bottom`}>
                <SubViewOptions
                    subView={subView}
                    changeSubViewManage={changeSubViewManage}
                />
                <div className='w-100 ml-4'>
                    {activeTab === DEDUCTION_POLICY_TAB.USER.key && (
                        <SearchSimple
                            id="search_user_deduction_policy"
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            setBodyForExport={setBodyForExport}
                            setSearchResults={setSearchResults}
                            optionTable={TABLES.PAYROLL_DEDUCTION_POLICY_USER}
                            rowsPerPage={10}
                            setSimpleSearch={setSimpleSearch}
                            search={search}
                            setSearch={setSearch}
                            contractorId={null}
                            supplierId={null}
                        />
                    )}
                </div>
            </div>

            <div className="border-full-shades-200 col-12 border-radius-8px px-0 mb-3">
                <CustomTabContainer
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    className="border-0 px-3"
                >
                    {visibleTabs.map((tab) => (
                        <CustomTab
                            key={tab.key}
                            id={tab.key}
                            title={t(tab.translation)}
                            icon={tab.icon}
                            selected={activeTab === tab.key}
                            onClick={() => { setActiveTab(tab.key); setSubViewChild?.(tab.key); setSearchElement(''); }}
                        />
                    ))}
                </CustomTabContainer>
            </div>

            {activeTab === DEDUCTION_POLICY_TAB.GLOBAL.key && (
                <GlobalDeductionPolicySection
                    registerAction={registerAction}
                    subView={subView}
                />
            )}

            {activeTab === DEDUCTION_POLICY_TAB.USER.key && (
                <UserDeductionPolicySection
                    registerAction={registerAction}
                    subView={subView}
                    searchElement={searchElement}
                    searchResults={searchResults}
                    setSearchResults={setSearchResults}
                    selectForDelete={selectForDelete}
                    setSelectForDelete={setSelectForDelete}
                    setIsAllChecked={setIsAllChecked}
                />
            )}
        </>
    );
};

export default DeductionPolicy;
